import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";

interface EnumState {
  // List ke liye
  loading: boolean;
  data: any;
  message: string;
  success: boolean;

  // Type ke liye
  typeLoading: boolean;
  typeData: any;
  typeMessage: string;
  typeSuccess: boolean;

  // Save (Add/Update) ke liye
  saveLoading: boolean;
  saveMessage: string;
  saveSuccess: boolean;

  // Delete Key ke liye
  deleteLoading: boolean;
  deleteMessage: string;
  deleteSuccess: boolean;

  // Delete Type ke liye
  deleteTypeLoading: boolean;
  deleteTypeMessage: string;
  deleteTypeSuccess: boolean;
}

const initialState: EnumState = {
  loading: false,
  data: {},
  message: "",
  success: false,

  typeLoading: false,
  typeData: {},
  typeMessage: "",
  typeSuccess: false,

  saveLoading: false,
  saveMessage: "",
  saveSuccess: false,

  deleteLoading: false,
  deleteMessage: "",
  deleteSuccess: false,

  deleteTypeLoading: false,
  deleteTypeMessage: "",
  deleteTypeSuccess: false,
};

const enumSlice = createSlice({
  name: "enum",
  initialState,
  reducers: {
    // =====================
    // Get Enum List
    // =====================
    getEnum(state, action: PayloadAction<any>) {
      state.loading = true;
      state.message = "";
    },
    getEnumSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload || {};
      state.success = action.payload.success;
      state.message = action.payload.message;
    },
    getEnumFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.success = action.payload.success;
      state.message = action.payload.message;
    },

    // =====================
    // Get Enum Type
    // =====================
    getEnumType(state, action: PayloadAction<any>) {
      state.typeLoading = true;
      state.typeMessage = "";
    },
    getEnumTypeSuccess(state, action: PayloadAction<ApiResponse>) {
      state.typeLoading = false;
      state.typeData = action.payload.data || {};
      state.typeSuccess = action.payload.success;
      state.typeMessage = action.payload.message;
    },
    getEnumTypeFailed(state, action: PayloadAction<ApiResponse>) {
      state.typeLoading = false;
      state.typeData = {};
      state.typeSuccess = action.payload.success;
      state.typeMessage = action.payload.message;
    },

    // =====================
    // Save Enum (Add/Update)
    // =====================
    saveEnum(state, action: PayloadAction<any>) {
      state.saveLoading = true;
      state.saveMessage = "";
    },
    saveEnumSuccess(state, action: PayloadAction<ApiResponse>) {
      state.saveLoading = false;
      state.saveSuccess = action.payload.success;
      state.saveMessage = action.payload.message;
    },
    saveEnumFailed(state, action: PayloadAction<ApiResponse>) {
      state.saveLoading = false;
      state.saveSuccess = action.payload.success;
      state.saveMessage = action.payload.message;
    },

    // =====================
    // Delete Enum Key
    // =====================
    deleteEnumKeyRequest(
      state,
      action: PayloadAction<{ enumType: string; keys: string[] }>
    ) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteEnumKeySuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteSuccess = action.payload.success;
      state.deleteMessage = action.payload.message;
    },
    deleteEnumKeyFailure(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteSuccess = action.payload.success;
      state.deleteMessage = action.payload.message;
    },

    // =====================
    // Delete Enum Type
    // =====================
    deleteEnumTypeRequest(state, action: PayloadAction<{ enumType: string }>) {
      state.deleteTypeLoading = true;
      state.deleteTypeMessage = "";
    },
    deleteEnumTypeSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteTypeLoading = false;
      state.deleteTypeSuccess = action.payload.success;
      state.deleteTypeMessage = action.payload.message;
    },
    deleteEnumTypeFailure(state, action: PayloadAction<ApiResponse>) {
      state.deleteTypeLoading = false;
      state.deleteTypeSuccess = action.payload.success;
      state.deleteTypeMessage = action.payload.message;
    },

    // =====================
    // Clear All
    // =====================
    clearEnum() {
      return initialState;
    },
  },
});

// Actions
export const enumAction = enumSlice.actions;

// =====================
// Selectors
// =====================
export const selectEnumData = (state: RootState) => state.enumModule.data;
export const selectEnumLoading = (state: RootState) => state.enumModule.loading;
export const selectEnumMessage = (state: RootState) => state.enumModule.message;
export const selectEnumSuccess = (state: RootState) => state.enumModule.success;

export const selectEnumTypeData = (state: RootState) =>
  state.enumModule.typeData;
export const selectEnumTypeLoading = (state: RootState) =>
  state.enumModule.typeLoading;
export const selectEnumTypeMessage = (state: RootState) =>
  state.enumModule.typeMessage;
export const selectEnumTypeSuccess = (state: RootState) =>
  state.enumModule.typeSuccess;

export const selectSaveEnumLoading = (state: RootState) =>
  state.enumModule.saveLoading;
export const selectSaveEnumSuccess = (state: RootState) =>
  state.enumModule.saveSuccess;
export const selectSaveEnumMessage = (state: RootState) =>
  state.enumModule.saveMessage;

export const selectDeleteEnumLoading = (state: RootState) =>
  state.enumModule.deleteLoading;
export const selectDeleteEnumSuccess = (state: RootState) =>
  state.enumModule.deleteSuccess;
export const selectDeleteEnumMessage = (state: RootState) =>
  state.enumModule.deleteMessage;

export const selectDeleteEnumTypeLoading = (state: RootState) =>
  state.enumModule.deleteTypeLoading;
export const selectDeleteEnumTypeSuccess = (state: RootState) =>
  state.enumModule.deleteTypeSuccess;
export const selectDeleteEnumTypeMessage = (state: RootState) =>
  state.enumModule.deleteTypeMessage;

// Reducer
export default enumSlice.reducer;
